import React, { Component } from 'react'

import UpdateProfileFields from '../../forms/UpdateProfileFields'
import Font from '../../atoms/Font'
import Modal from '../../atoms-v2/Modal'
import * as user from '../../../utils/userData'

import T from '../../../SPRINTA/translate/T'

export default class CompleteRegistration extends Component {

    state = {
        active: false,
        fields: []
    }

    componentDidMount() {
        this.componentWillReceiveProps(this.props)
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.active && !this.verified) {
            this.props.handleOpened()
            this.verified = true
            user.verifyToInscription()
            .then(resp => {
                if(resp.errors) {
                    let fields = []
                    resp.errors.map(error => {
                        return fields.push(error.parameter_name)
                    })

                    this.setState({
                        active: true,
                        fields
                    })
                } else {
                    this.handleComplete()
                }
            })
        }

    }

    handleComplete() {
        this.setState({
            active: false
        })
        this.props.handleDone()
    }

    render() {
        return (
            <Modal style={{width: '500px'}} hideClose={true} active={this.state.active} handleClose={() => {}}>
                <div style={{textAlign: 'center'}}>
                    <span style={{ fontSize: '30px' }}>{T.text('first_of_all')}</span>
                    <Font style={{marginTop: '20px', fontSize: '14px', marginBottom: '40px'}}>
                        {T.text('information_incomplete')}
                    </Font>

                    <UpdateProfileFields fields={this.state.fields} onUpdate={() => { this.handleComplete() }} />
                </div>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/container/CompleteRegistration/index.js